import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductGetters } from '~/composables/useProductGetters';
import { useReactiveProductGetters } from '~/composables/useReactiveProductGetters';

export function useCommonProductGetters() {
  const { isShopTheSetExpEnabled } = useFeatureEligibility();

  if (isShopTheSetExpEnabled) {
    return useReactiveProductGetters();
  }
  return useProductGetters();
}
